import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap gap-4 mb-4" }
const _hoisted_2 = { class: "basis-full lg:basis-48" }
const _hoisted_3 = { class: "basis-full lg:basis-48" }
const _hoisted_4 = { class: "basis-full lg:basis-48" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row flex-wrap gap-4"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Сбросить фильтры ")

import { TrashIcon } from '@heroicons/vue/outline';
import { computed, reactive, ref, watch } from 'vue';
import { useDebounceFn } from '@vueuse/core';

import { AppSelect, defaultClasses, Classes } from './AppSelect';
import { Attribute } from '../types/Attribute';
import { AvailableFilters } from '../types/AvailableFilters';
import { Value } from '../types/Value';
import { formatDataType } from '../formatters/valueFormatters';
import { RequestFilters } from '../types/RequestFilters';


export default /*#__PURE__*/_defineComponent({
  props: {
    requestFilters: null,
    availableFilters: null,
    isLoading: { type: Boolean }
  },
  emits: ["update:filters"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:filters', filters: RequestFilters): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  requestFilters: RequestFilters;
  availableFilters: AvailableFilters;
  isLoading: boolean
}





const sortedFilterAttributes = computed(() => {
  return [...props.availableFilters.attributes].sort((a, b) => {
    return a.groupId - b.groupId || a.order - b.order || a.title.localeCompare(b.title, ['en', 'ru'], {numeric: true});
  });
});

const sortedAttributeValues = (attribute: Attribute) => {
  if (attribute.dataType === 'country') {
    return attribute.values.sort((a, b) => {
      return (formatDataType(attribute.dataType, a.value) + '').localeCompare(formatDataType(attribute.dataType, b.value), ['en', 'ru'], {numeric: true});
    })
  }
  
  return attribute.values;
}

const emptyFilters: RequestFilters = {
  brandsIds: [],
  attributes: [],
  categoryId: null,
};

const selectedFilters = reactive<RequestFilters>(props.requestFilters);

watch(() => {
  return props.requestFilters;
}, filters => {
  //console.log('watch: props.requestFilters', filters)
  assignFilters(filters);
});

function getAttributeFilter(attributeId) {
  if (selectedFilters.attributes) {
    return selectedFilters.attributes[attributeId];
  }
  return null;
}

function setAttributeFilter(attributeId, values) {
  // console.log('setAttributeFilter', {
  //   attributeId,
  //   values,
  // });
  
  if (!selectedFilters.attributes) {
    selectedFilters.attributes = {};
  }
  
  if (values.length > 0) {
    selectedFilters.attributes[attributeId] = values;
  } else {
    delete selectedFilters.attributes[attributeId];
  }
  
  applyFilters();
}

function assignFilters(newFilters: RequestFilters) {
  Object.assign(selectedFilters, {
    ...newFilters,
    brandsIds: [...(newFilters.brandsIds || [])],
    attributes: { ...(newFilters.attributes || []) },
  });
}

function resetFilters() {
  // console.log('resetFilters', {
  //   selectedFilters,
  //   emptyFilters,
  // });
  
  assignFilters(emptyFilters);
  applyFilters();
}

const applyFilters = useDebounceFn(() => {
  // console.log('applyFilters', {
  //   selectedFilters,
  // });
  
  emit('update:filters', selectedFilters);
}, 1000)

function getAttributeOptionLabel(attribute: Attribute, option: Value) {
  return formatDataType(attribute.dataType, option.value);
}

const hasFilters = computed(() => {
  return true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(AppSelect), {
          modelValue: _unref(selectedFilters).yearId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selectedFilters).yearId) = $event)),
          options: __props.availableFilters.years,
          title: "Год",
          "option-label": "value",
          "option-value": "id",
          classes: _unref(defaultClasses),
          "is-loading": __props.isLoading,
          onChange: _unref(applyFilters)
        }, null, 8, ["modelValue", "options", "classes", "is-loading", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(AppSelect), {
          modelValue: _unref(selectedFilters).categoryId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(selectedFilters).categoryId) = $event)),
          options: __props.availableFilters.categories,
          title: "Тип техники",
          "option-label": "title",
          "option-value": "id",
          classes: _unref(defaultClasses),
          "is-loading": __props.isLoading,
          onChange: _unref(applyFilters)
        }, null, 8, ["modelValue", "options", "classes", "is-loading", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(AppSelect), {
          modelValue: _unref(selectedFilters).brandsIds,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(selectedFilters).brandsIds) = $event)),
          options: __props.availableFilters.brands,
          multiple: true,
          title: "Бренды",
          "option-label": "title",
          "option-value": "id",
          classes: _unref(defaultClasses),
          "is-loading": __props.isLoading,
          onChange: _unref(applyFilters)
        }, null, 8, ["modelValue", "options", "classes", "is-loading", "onChange"])
      ])
    ]),
    (_unref(sortedFilterAttributes).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedFilterAttributes), (attribute) => {
            return (_openBlock(), _createElementBlock("div", {
              key: attribute.id,
              class: "basis-full lg:basis-auto"
            }, [
              _createVNode(_unref(AppSelect), {
                "model-value": getAttributeFilter(attribute.id),
                options: sortedAttributeValues(attribute),
                title: attribute.title,
                "option-label": getAttributeOptionLabel.bind(null, attribute),
                "option-value": "value",
                multiple: true,
                classes: _unref(defaultClasses),
                "is-loading": __props.isLoading,
                "onUpdate:modelValue": ($event: any) => (setAttributeFilter(attribute.id, $event))
              }, null, 8, ["model-value", "options", "title", "option-label", "classes", "is-loading", "onUpdate:modelValue"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(hasFilters))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "flex items-center py-1 px-3 text-sm text-zinc-100 bg-teal-600 hover:bg-teal-500 rounded cursor-pointer select-none lg:inline-flex",
            onClick: resetFilters
          }, [
            _createVNode(_unref(TrashIcon), { class: "mr-2 w-4 h-4" }),
            _hoisted_7
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})